<template>
	<!-- <popPicker  :defaultIndex='0' :columns=[] :title="''" :placeholder="''" :isOptionCenter="true/false" :rightButtonName="" :leftButtonName="" @confirm=>"d=>()"></popPicker> -->
	<div>
		<div class="w100pct h405x boxR selectBox posR pt2x pb2x" @click="showPicker = true">
			<span class="text flex100 fsField">{{ newValue.text || getLanguageStr("word806", "请选择") }}</span>
			<span class="moreB"><van-icon name="play" class="s-more" /></span>
		</div>
		<!-- <van-field readonly clickable :value="newValue.text" :placeholder="placeholder" @click="showPicker = true">
			<template #right-icon>
				<span class="moreB"><van-icon name="play" class="s-more" /></span>
			</template>
		</van-field> -->

		<van-popup v-model="showPicker" position="bottom" :get-container="'body'">
			<van-picker
				:class="{ leftItem: !isOptionCenter }"
				:title="title"
				:confirm-button-text="rightButtonName"
				:cancel-button-text="leftButtonName"
				show-toolbar
				:columns="columns"
				:default-index="defaultIndex"
				toolbar-class="top-green"
				@cancel="showPicker = false"
				@confirm="onConfirm"
				@change="changeValue"
			>
			</van-picker>
			<!-- <slot name="columns-top">111</slot> -->
		</van-popup>
	</div>
</template>

<script>
import { Picker, Popup, Field } from "vant";
import * as lib from "@/util/lib";
import Vue from "vue";
Vue.use(Picker).use(Popup).use(Field);
export default {
	// name: 'DeviceControl',
	components: {},
	props: {
		title: {
			type: String,
			default: "",
		},
		placeholder: {
			type: String,
			default: "",
		},
		columns: {
			type: Array,
			default: () => [{ text: "", value: -1 }],
		},
		isOptionCenter: {
			// 选项是否居中显示
			type: Boolean,
			default: true,
		},
		rightButtonName: {
			type: String,
			default: getLanguageStr("cmd12", "确定"),
		},
		leftButtonName: {
			type: String,
			default: getLanguageStr("cmd85", "取消"),
		},
		value: {
			type: Object,
			default: () => ({}),
		},
		defaultIndex: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			newValue: this.value,
			showPicker: false,
		};
	},
	watch: {
		defaultIndex: {
			handler() {},
		},
		deep: true,
	},
	methods: {
		getLanguageStr,
		timeFormat: lib.timeFormat,
		getTypeText: lib.getTypeText,
		doPermissions: lib.doPermissions,
		onConfirm(value) {
			this.newValue = value;
			this.$emit("input", value);
			this.$emit("confirm");
			this.showPicker = false;
		},
		changeValue() {},
	},
	mounted() {
		// console.log(this.defaultIndex, "值");
		this.$nextTick(() => {
			this.newValue = this.columns.find((item) => {
				return item.val == this.defaultIndex + 1;
			});
		});

		// console.log(newValue, "新值");
	},
};
</script>
<style lang="scss" scoped>
.leftItem {
	::v-deep .van-picker-column__item {
		justify-content: flex-start;
		margin-left: 4vmin;
	}
}
::v-deep .moreB {
	position: absolute;
	top: 50%;
	right: 3.1vmin;
	transform: translate(0, -50%) rotate(90deg);
}
::v-deep .s-more {
	color: rgb(150, 151, 153);
}
::v-deep .van-field__control {
	padding-left: 1.5rem;
}
::v-deep .van-cell {
	padding-right: 0vmin;
	padding-left: 0vmin;
}
::v-deep .van-cell::after {
	border: none;
}
::v-deep input[readonly] {
	background-color: #f3f3f6;
}

::v-deep .van-field__right-icon {
	color: rgba(0, 0, 0, 0.65);
}
::v-deep .van-field__left-icon .van-icon,
.van-field__right-icon .van-icon {
	// font-size: 14px;
}
.selectBox {
	padding-right: 3.2vmin;
	padding-left: 3.2vmin;
	background-color: #f3f3f6;
}
::v-deep .van-picker__title {
	font-size: 4.26667vmin;
	color: rgba(0, 0, 0, 0.85);
}
::v-deep .van-picker__cancel {
	color: #a3a7b4;
}
::v-deep .van-picker__confirm {
	color: #048fff;
}
</style>
<style>
/* .van-field__clear,
.van-field__right-icon {
	padding: 0 0 !important;
} */
</style>



// WEBPACK FOOTER //
// src/view/device/device/part/PopPickerSelect.vue